export enum UserStatus {
  ACTIVE = 'ACTIVE',
  ACTIVATION_PENDING = 'ACTIVATION_PENDING',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  SHARED_USER = 'SHARED_USER'
}